import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { RootState } from '@/store'
import { AxiosList, Data } from '@/modules/common/apiConfig'
import { Document, UploadableDocumentType } from '@/modules/documents/types/documentTypes'
import axios from 'axios'

export type State = {
	documents: Document[]
}

export const state = (): State => ({
	documents: [],
})

export type DocumentUpload = {
	type: UploadableDocumentType
	title: string | null
	file: File
}

const mutations: MutationTree<State> = {
	setDocuments(state: State, documents: Document[]) {
		state.documents = documents
	},
}

const actions: ActionTree<State, RootState> = {
	async getDocuments({ commit }): Promise<void> {
		const { data }: AxiosList<Document> = await axios.get('/restify/documents', {
			params: {
				sort: '-created_at',
				perPage: 100,
			},
		})

		commit(
			'setDocuments',
			data.map((document: Data<Document>) => document.attributes),
		)
	},
	async getDocumentByUuid(_, uuid: string): Promise<Document | null> {
		const { data }: AxiosList<Document> = await axios.get('/restify/documents', {
			params: { uuid },
		})

		return data[0]?.attributes ?? null
	},
	async uploadDocument({ dispatch }, upload: DocumentUpload): Promise<void> {
		const form = new FormData()
		form.append('type', upload.type)
		form.append('document', upload.file)

		if (upload.title) {
			form.append('title', upload.title)
		}

		await axios.post('/restify/documents/actions?action=upload', form)
		await dispatch('getDocuments')
	},
}

const getters: GetterTree<State, RootState> = {}

const module: Module<State, RootState> = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}

export default module
